import { DeductionTypeEnumContract } from '../types/contracts';

export const isPlanDependenciesDisabled = (
    selectedDeductionTypeId: string,
    hasExistingDependencies: boolean,
): boolean => {
    return !hasExistingDependencies && (!selectedDeductionTypeId || selectedDeductionTypeId === DeductionTypeEnumContract.dependentCare);
};
